module.exports = __webpack_public_path__ + "static/media/arrow-right.62ebffd8.svg";